/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomInvitationFromJSON, StreemApiRoomInvitationToJSON, } from './';
export function StreemApiListUserInvitationsResponseFromJSON(json) {
    return StreemApiListUserInvitationsResponseFromJSONTyped(json, false);
}
export function StreemApiListUserInvitationsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomInvitations': !exists(json, 'room_invitations') ? undefined : (json['room_invitations'].map(StreemApiRoomInvitationFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListUserInvitationsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_invitations': value.roomInvitations === undefined ? undefined : (value.roomInvitations.map(StreemApiRoomInvitationToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListUserInvitationsResponse.js.map